import {AfterViewInit, Directive, ElementRef, OnInit} from "@angular/core";
import {ScriptLoaderService} from "../services/script-loader.service";

declare var jquery: any;
declare var $: any;

@Directive({
  selector: '[appStarRating]'
})
export class StarRatingDirective implements OnInit, AfterViewInit {
  currentElement: any;


  constructor(private _script: ScriptLoaderService, private el: ElementRef) {
    this.currentElement = el;
  }

  ngOnInit() {
    this._script.load('.container', './assets/js/star-rating.min.js');
  }

  ngAfterViewInit() {

      $(".star-rating").rating({
        step: 1,
        starCaptions: {
          1: 'Terrible',
          2: 'Poor',
          3: 'Average',
          4: 'Very good',
          5: 'Excellent'
        }
      });
  }


}


// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/directives/star-rating.directive.ts